import { PayCycleAvailableDocumentTypes } from 'ap/paymentCycle/__generated__/PayCycleAvailableDocumentTypes';
import { GetPayCycleDetails_payCycle } from 'ap/paymentCycle/view/__generated__/GetPayCycleDetails';
import { PayCycleValues } from 'ap/paymentCycle/view/types';
import React from 'react';
import { AttachFormModal } from './AttachFormModal';
import { useFormContext } from 'react-hook-form';

export interface AttachFormProps {
  paymentCycle: GetPayCycleDetails_payCycle;
  availableDocumentTypes: PayCycleAvailableDocumentTypes | undefined;
}
export const AttachForm: React.FC<AttachFormProps> = ({
  paymentCycle,
  availableDocumentTypes
}) => {
  const {
    formState: { isDirty },
  } = useFormContext<PayCycleValues>();
  return (

    <AttachFormModal
      paymentCycle={paymentCycle}
      availableDocumentTypes={availableDocumentTypes}
      dirty={isDirty}
    />

  );
}
